export default {
  de: {
    dashboard: {
      open_events: "Noch offene Meldungen",
      following_events: "Kommende Turniere",
      booked_events: "Abgeschlossene Meldungen",
    },
    pages: {
      dancers: {
        unlock: "Tänzer freigeben",
        unlock_description:
          "Geburtsdatum aller Tänzer auf den 01.01 des Geburtsjahres setzen",
      },
    },
    add_registration: "Meldung hinzufügen",
    pay_with_sofort: "Mit Sofort bezahlen",
    pay_with_invoice: "Per Rechnung zahlen (Zahlungsziel: {0} Tage)",
    unpaid: "noch nicht bezahlt",
    paid: "bereits bezahlt",
    download_overview: "Übersicht herunterladen",
    print: "Drucken",
    country: "Land",
    invoice_success: "Rechnung erfolgreich erstellt",
    pay: "Zahlen",
    download: "Download",
    submit_registrations: "Anmelden",
    buy_registrations: "Zahlungspflichtig bestellen",
    contains_broken_dancers:
      "Starter enthält Tänzer ohne gültiges Geburtsdatum",
    add_from_starter_templates: "Aus vorhandenen Startern hinzufügen",
    add: "Hinzufügen",
    select_starters: "Starter auswählen",
    select_dancers: "Tänzer auswählen",
    add_starter: "Starter hinzufügen",
    data_protection: "Einverständnis",
    data_protection_text:
      "Zur Speicherung personenbezogener Daten Minderjähriger muss Ihnen eine Einverständniserklärung der Erziehungsberechtigten vorliegen. Sie können das dazu benötigte Dokument hier oder im Impressum downloaden.",
    conditions: "Allgemeine Geschäftsbedingungen",
    conditions_text:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam blanditiis consequatur, dolor ea eos, error, est et eum harum ipsum laboriosam laudantium maxime natus nemo odit officiis quae sunt!",
    privacy: "Datenschutzerklärung",
    contest_rules: "Wettkampfregeln",
    no_results: "Keine Ergebnisse",
    logout: "Logout",
    really_logout: "Wirklich ausloggen?",
    do_you_really_wanna_logout: "Wollen Sie sich wirklich ausloggen?",
    user_options: "Optionen",
    white_navigation: "Weiße Navigation",
    white_toolbar: "Weiße Toolbar",
    app_name: "SDF Meldeportal",
    age: "Alter",
    registration_ended: "Registrierungen sind nicht mehr möglich",
    can_register_starter: "Starter kann gemeldet werden",
    cant_register_starter: "Starter wurde bereits zu allen Styles angemeldet",
    print_invoices: "Rechnungen drucken",
    combinations: "Kombinationen",
    remove_combination: "Letzte Kombination entfernen",
    add_combination: "Kombination hinzufügen",
    add_price: "Preis hinzufügen",
    remove_price: "Letzten Preis entfernen",
    remove_starters: "Unbestätigte Meldungen entfernen",
    female: "weiblich",
    male: "männlich",
    non_binary: "divers",
    csv: "CSV",
    event_mails: "Rundmail",
    stats: "Statistik",
    gender_select: "Anrede",
    invoice_download: "Rechnungen herunterladen",
    media_download: "Medien herunterladen",
    music_download: "Musik/Video herunterladen",
    music_uploaded: "Musik/Video wurde hochgeladen",
    video_download: "Musik/Video herunterladen",
    video_uploaded: "Musik/Video wurde hochgeladen",
    music_uploaded_error: "Musik/Video konnte nicht hochgeladen werden",
    music_uploaded_success: "Musik/Video wurde erfolgreich hochgeladen",
    video_uploaded_error: "Musik/Video konnte nicht hochgeladen werden",
    video_uploaded_success: "Erfolgreich hochgeladen",
    music_is_uploading: "Upload wurde gestartet",
    video_is_uploading: "Upload wurde gestartet",
    music_is_uploading_warning:
      "Bitte warten bis Musik/Video vollständig hochgeladen wurde",
    video_is_uploading_warning:
      "Bitte warten bis Musik/Video vollständig hochgeladen wurde",
    play_music: "Musik/Video abspielen",
    play_video: "Musik/Video abspielen",
    stop_music: "Musik/Video stoppen",
    stop_video: "Musik/Video stoppen",
    upload_music: "Musik/Video hochladen",
    upload_video: "Musik/Video hochladen",
    upload_new_music: "Musik/Video ersetzen",
    upload_new_video: "Musik/Video ersetzen",
    missing_music: "Musik/Video fehlt",
    missing_video: "Musik/Video fehlt",
    status: "Status",
    city_championship: "Stadtmeisterschaft",
    regional_championship: "Regionalmeisterschaft",
    german_championship: "Deutsche Meisterschaft",
    europe_championship: "Europameisterschaft",
    world_championship: "Weltmeisterschaft",
    open_championship: "Offene Meisterschaft",
    download_invoice: "Rechnung herunterladen",
    choose_event: "Turnier auswählen",
    user_returned: "Ins eigene Profil gewechselt",
    switch_user: "Benutzer wechseln",
    select_user: "Benutzer auswählen",
    details: "Details",
    starter_style: "Style",
    age_group: "Altersklasse",
    starter_type: "Typ",
    event_name: "Name des Turniers",
    date: "Datum",
    fake_register_end: "Meldeschluss",
    start: "Start",
    end: "Ende",
    choose_file: "Musik-Datei auswählen",
    register: "Registrieren",
    save: "Speichern",
    save_and_new: "Speichern und Neu",
    ok: "OK",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    close: "Schließen",
    new_password: "Neues Passwort",
    repeat_password: "Passwort wiederholen",
    forgot_password: "Passwort vergessen?",
    email_address: "E-Mail Adresse",
    email_address_from_dancer: "E-Mail Adresse des Tänzers",
    password: "Passwort",
    remember_me: "Eingeloggt bleiben",
    login_not_possible: "Login derzeit nicht möglich",
    was_deleted: "{0} wurde gelöscht",
    was_saved: "{0} wurde gespeichert",
    was_printed: "Rechnungen für {0} werden erzeugt",
    edit_dancer: "Tänzer/in bearbeiten",
    create_dancer: "Tänzer/in erstellen",
    edit_starter: "Starter bearbeiten",
    create_starter_for_event: "Neuen Starter für das Turnier erstellen",
    create_starter: "Starter erstellen",
    edit_event: "Turnier bearbeiten",
    create_event: "Turnier erstellen",
    delete_starter: "Starter löschen",
    delete_event: "Turnier löschen",
    delete_liveStream: "Live-Stream löschen",
    delete_videoGroup: "Videogruppe löschen",
    delete_video: "Video löschen",
    sex: "Geschlecht",
    name_of_starter: "Name des Starters",
    name: "Name",
    first_name: "Vorname",
    last_name: "Nachname",
    birth_date: "Geburtsdatum",
    birth_date_entry: "Geburtsdatum (tt.mm.jjjj)",
    edit: "Bearbeiten",
    delete: "Löschen",
    continue: "Weiter",
    back: "Zurück",
    dancers: "Tänzer- /innen",
    dancer_count: "Anzahl Tänzer",
    starter_template: "Starter",
    starter_templates: "Starter",
    organizer: "Ausrichter",
    host: "Location",
    street: "Straße",
    street_number: "Hausnummer",
    postcode: "PLZ",
    town: "Stadt",
    price: "Gebühr",
    first_price: "Erstgebühr",
    price_reduced: "Folgegebühr",
    max_price_per_dancer: "Maximale Gebühr p. Tänzer",
    user: "Institution",
    user_switched: "Angemeldet als {0}",
    event_rules: "Regelwerk",
    event: "Turnier",
    unregister_all_starters: "Offene Meldungen entfernen",
    register_starter: "Starter anmelden",
    register_starter_final: "Zahlungspflichtig anmelden",
    event_registration: "Turnieranmeldung",
    type: "Typ",
    battle: "Battle",
    battle_duo: "Battle Duo",
    battle_small_team: "Battle Small Team",
    solo: "Solo",
    solo_male: "Solo männlich",
    solo_female: "Solo weiblich",
    solo_show: "Solo Show",
    solo_fusion_show: "Solo FusionShow",
    duo: "Duo",
    duo_show: "Duo Show",
    duo_fusion_show: "Duo FusionShow",
    group: "Gruppe",
    formation: "Formation",
    trio: "Trio",
    small_team: "Small Team",
    large_team: "Large Team",
    showcase: "Showcase",
    super_showcase: "Super Showcase",
    battle_1vs1: "Battle 1 vs. 1",
    battle_2vs2: "Battle 2 vs. 2",
    battle_3vs3: "Battle 3 vs. 3",
    starter_registration_success: "Starter erfolgreich angemeldet",
    starter_already_exists: "Starter existiert bereits",
    starter_name_already_exists: "Starter mit gleichem Namen existiert bereits",
    starter_cannot_be_saved: "Starter kann nicht erstellt werden",
    dancer_still_used_in_starter:
      "Tänzer wird noch in mindestens einem Starter verwendet",
    no_more_possible_starter_types:
      "Es sind keine weiteren Meldungen für ”{0}” möglich",
    forms: {
      missing_birthday: "Geburtsdatum fehlt",
      same_address_for_invoice: "Adresse ist auch Rechnungsadresse",
    },
    alerts: {
      create_dancer_before_starter:
        "Es müssen Tänzer anlegen werden, um Starter erstellen zu können",
      fix_user_data:
        "Füllen Sie alle erforderlichen Daten aus, um fortzufahren",
      fix_dancer_birthday: "Korrigieren Sie das Geburtsdatum",
      fix_dancers_birthday:
        "Geben Sie die vollständigen Geburtsdaten der Tänzer ein",
    },
    questions: {
      unregister_all_starters:
        "Es werden alle noch offenen Meldungen für ”{0}” entfernt.",
      remove: "{0} wirklich löschen?",
      leave_registration:
        "Du verlässt jetzt den Anmeldevorgang. Deine Daten werden zwischengespeichert und stehen Dir zur weiteren Bearbeitung zur Verfügung, wenn Du das Turnier unter 'Turniere' erneut auswählst.",
      submit_registration_with_invoices:
        "Indem Du auf 'Bestätigen' klickst, führst Du die in der Übersicht aufgeführten Meldungen zahlungspflichtig aus. Änderungen und Stornierungen sind danach nicht mehr möglich.",
      submit_registration_without_invoices:
        "Indem Du auf 'Bestätigen' klickst, führst Du die in der Übersicht aufgeführten Meldungen verbindlich aus. Änderungen und Stornierungen sind danach nur noch in direkter Absprache mit dem Ausrichter möglich.",
    },
    rules: {
      missing_name: "Name fehlt",
      missing_dancers: "Keine Tänzer ausgewählt",
      too_long: "{0} zu lang",
    },
    menu: {
      items: {
        dancers: "Tänzer verwalten",
        starters: "Starter verwalten",
        events: "Zum Turnier anmelden",
        event_registration_list: "Meine Meldungen",
        settings: "Einstellungen",
        liveStreams: "Streams",
        videos: "Videos",
        admin: {
          contests: "Turnierverwaltung",
          contest_reports: "Meldestand",
          users: "Institutionen",
          environment: "Umgebung",
          translations: "Übersetzungen",
          refund: "Storno",
          liveStreams: "Stream-Verwaltung",
          videoGroups: "Videogruppen",
          videos: "Video-Verwaltung",
        },
      },
    },
    errors: {
      common_error: "Es ist ein Fehler aufgetreten",
      user_already_exists:
        "Es existiert bereits ein Benutzer mit der E-Mail Adresse",
      email_already_taken: "Die E-Mail Adresse ist bereits vergeben",
      email_not_validated: "Die E-Mail Adresse wurde noch nicht bestätigt",
      email_or_password_wrong: "E-Mail oder Passwort falsch",
      dancer_already_exists: "Tänzer existiert bereits",
      missing_dancers: "Keine Tänzer ausgewählt",
      too_much_dancers_for_late_registration:
        "Zu viele Tänzer für aktuellen Startertyp",
      not_possible_for_starter_type:
        "Nicht möglich für hinterlegten Startertyp",
      sevdesk_offline: "SevDesk ist aktuell nicht erreichbar",
      no_starter_templates_for_registration:
        "Keine Starter zur Meldung verfügbar",
    },
  },
  en: {
    register: "register",
    save: "save",
    cancel: "cancel",
    confirm: "confirm",
    close: "close",
    forgot_password: "Forgot password?",
    email_address: "email address",
    password: "password",
    remember_me: "Remember me",
    login_not_possible: "Login currently not possible",
    dancer_was_deleted: "{0} was deleted",
    create_dancer: "create dancer",
    create_event: "create event",
    sex: "sex",
    first_name: "first name",
    last_name: "last name",
    birth_date: "birth date",
    edit: "Edit",
    delete: "Delete",
    questions: {
      remove: "Delete {0}?",
      submit_registration_with_invoices: "",
    },
    menu: {
      items: {
        dancers: "Dancers",
        starters: "Starters",
        settings: "Settings",
        event_registration_list: "Registrations",
      },
    },
    errors: {
      email_or_password_wrong: "E-Mail or password wrong",
    },
    conditions: "conditions",
    country: "country",
  },
};
